var _style, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTutorType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{display:none;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Face_Scan"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496,376h-32c-4.4,0-8,3.6-8,8v72h-72c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8h80c22.1,0,40-17.9,40-40v-80 C504,379.6,500.4,376,496,376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464,8h-80c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8h72v72c0,4.4,3.6,8,8,8h32c4.4,0,8-3.6,8-8V48 C504,25.9,486.1,8,464,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,456H56v-72c0-4.4-3.6-8-8-8H16c-4.4,0-8,3.6-8,8v80c0,22.1,17.9,40,40,40h80c4.4,0,8-3.6,8-8v-32 C136,459.6,132.4,456,128,456z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,136h32c4.4,0,8-3.6,8-8V56h72c4.4,0,8-3.6,8-8V16c0-4.4-3.6-8-8-8H48C25.9,8,8,25.9,8,48v80 C8,132.4,11.6,136,16,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184,223.9V280c0,39.8,32.2,72,72,72s72-32.2,72-72v-66.8c-11.4-5-22.2-11.3-32.2-18.7 C283.3,203.7,249.7,222.5,184,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.9,239.7c8.1-5,17.5-7.7,27.1-7.7h12v-16c0-4.4,3.6-8,8-8c83.8,0,114-29.3,114.3-29.6 c3.2-3,8.1-3.1,11.4-0.1c11.3,9.3,23.9,16.8,37.4,22.3c3,1.2,5,4.1,5,7.4v24h12c9.9-0.1,19.6,2.8,27.9,8.2 c10.7-31.1,10.8-64.9,0.5-96.2c-14.9-45-47.8-70.5-92.6-71.9c-74.4-2.3-98.7,33.7-105.4,48.1c-21.4,0.8-41.3,11.2-54.4,28.2 C117.4,169.4,116.3,200.2,128.9,239.7L128.9,239.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192,340.4V376c0,35.3,28.7,64,64,64s64-28.7,64-64v-35.6c-33.4,35.3-89.1,37-124.4,3.6 C194.4,342.8,193.2,341.6,192,340.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168,248h-12c-19.9,0-36,16.1-36,36c0.1,19.8,16.2,35.9,36,36h21.6c-6.3-12.4-9.6-26.1-9.6-40V248z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392,284c-0.1-19.8-16.2-35.9-36-36h-12v32c0,13.9-3.3,27.6-9.6,40H356C375.9,320,392,303.9,392,284z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.6,249c22.4,0,41.8-8,57.7-23.9c15.9-15.9,23.9-35.3,23.9-57.7s-8-41.8-23.9-57.7S276,85.8,253.6,85.8 s-41.8,8-57.7,23.9S172,145,172,167.4s8,41.8,23.9,57.7C211.8,240.9,231.2,249,253.6,249z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.3,346.2c-0.5-6.6-1.4-13.8-2.7-21.4c-1.4-7.7-3.1-14.9-5.3-21.5c-2.2-6.8-5.2-13.6-8.8-20.1 c-3.8-6.7-8.3-12.6-13.3-17.4c-5.3-5-11.7-9.1-19.2-12c-7.4-2.9-15.7-4.4-24.5-4.4c-3.5,0-6.8,1.4-13.3,5.6c-4,2.6-8.6,5.6-13.8,8.9 c-4.4,2.8-10.4,5.5-17.9,7.9c-7.2,2.3-14.6,3.5-21.9,3.5c-7.3,0-14.6-1.2-21.9-3.5c-7.4-2.4-13.4-5-17.9-7.9 c-5.1-3.3-9.8-6.3-13.8-8.9c-6.4-4.2-9.8-5.6-13.3-5.6c-8.8,0-17,1.5-24.5,4.4c-7.4,2.9-13.9,7-19.2,12c-5,4.8-9.5,10.7-13.3,17.4 c-3.7,6.5-6.7,13.2-8.8,20.1c-2.1,6.6-3.9,13.9-5.3,21.5s-2.3,14.8-2.7,21.4c-0.4,6.5-0.7,13.2-0.7,20c0,17.7,5.6,32,16.7,42.5 c10.9,10.4,25.4,15.7,43,15.7H337c17.6,0,32.1-5.3,43-15.7c11.1-10.5,16.7-24.9,16.7-42.6C397,359.4,396.8,352.7,396.3,346.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorType);
export default __webpack_public_path__ + "static/media/tutor-type.aabfe652f030d259687e34855a65dfbd.svg";
export { ForwardRef as ReactComponent };